module.exports = __webpack_public_path__ + "static/img/hdw4.75f18dc0.jpg";